// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingScreen_wrapper__2EwnT"};